/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

export const Loading = styled.div`
  align-items: center;
  display: flex;
  height: 60vh;
  justify-content: center;
`;
